import { frontendURL } from '../../../../helper/URLHelper';

const finops = accountId => ({
  parentNav: 'finops',
  routes: ['finops_dashboard', 'finops_typebot_navigation'],
  menuItems: [
    {
      icon: 'building-bank',
      label: 'FINOPS_DASHBOARD',
      hasSubMenu: false,
      truncateLabel: true,
      toState: frontendURL(`accounts/${accountId}/finops/dashboard`),
      toStateName: 'finops_dashboard',
    },
    {
      icon: 'navigation',
      label: 'FINOPS_TYPEBOT',
      hasSubMenu: false,
      truncateLabel: true,
      toState: frontendURL(`accounts/${accountId}/finops/typebot`),
      toStateName: 'finops_typebot_navigation',
    },
  ],
});

export default finops;
